import { render, staticRenderFns } from "./deductionList-no.vue?vue&type=template&id=c8a4ae7c&scoped=true"
import script from "./deductionList-no.vue?vue&type=script&lang=js"
export * from "./deductionList-no.vue?vue&type=script&lang=js"
import style0 from "./deductionList-no.vue?vue&type=style&index=0&id=c8a4ae7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a4ae7c",
  null
  
)

export default component.exports